/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom } from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom';
import {
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomToJSON,
} from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed
 */
export interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed {
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed
     */
    name?: string;
    /**
     * 
     * @type {IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom}
     * @memberof IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed
     */
    room?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerOccupanciesInnerBed(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'room': !exists(json, 'room') ? undefined : IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSON(json['room']),
    };
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedToJSON(value?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'room': IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomToJSON(value.room),
    };
}

